import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { HeartHandshake } from "lucide-react";
import { useAuth } from "@/App";
import { BereichSeite } from "@/components/crm/Bereich";
import CRMPlanung from "@/components/crm/CRMPlanung";
import CRMEinsatzKunden, { CRMVerfuegbarkeiten } from "@/components/crm/CRMEinsatzKunden";
import CRMAnfragen from "@/components/crm/CRMAnfragen";
import CRMAufgaben from "@/components/crm/CRMAufgaben";
import CRMKundenkontakte from "@/components/crm/tl/CRMKundenkontakte";
import CRMWerbung from "@/components/crm/tl/CRMWerbung";
import { CRMAusfaelle } from "@/components/crm/Phase3CRM";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CRMAlltag() {
  const { user } = useAuth();
  const [z, setZ] = useState({});
  useEffect(() => {
    const H = { headers: { Authorization: `Bearer ${user.token}` } };
    axios.get(`${API}/einsatz/abwesenheiten?status=beantragt`, H).then((r) => setZ((p) => ({ ...p, urlaub: r.data.length }))).catch(() => {});
    axios.get(`${API}/planung/vorgaenge?status=laufend`, H).then((r) => setZ((p) => ({ ...p, vorgaenge: r.data.length }))).catch(() => {});
    axios.get(`${API}/aufgaben/uebersicht?status=klaerung`, H).then((r) => setZ((p) => ({ ...p, klaerung: r.data.aufgaben.length }))).catch(() => {});
  }, [user]);
  const Sub = ({ gruppe, subs }) => <SubTabs gruppe={gruppe} subs={subs} />;
  const kundenSubs = [["liste", "Kunden", () => <CRMEinsatzKunden />], ["kontakte", "Kundenkontakte", () => <CRMKundenkontakte />], ...(user.role === "admin" ? [["anfragen", "Anfragen", () => <CRMAnfragen bereich="alltagsbegleitung" />]] : [])];
  const meldungSubs = [["aufgaben", "Aufgaben", () => <CRMAufgaben />], ["ausfaelle", "Einsatzausfälle", () => <CRMAusfaelle />]];
  const tabs = [
    { key: "planung", label: "Tourenoptimierung", kurz: "Touren", count: z.vorgaenge, render: () => <CRMPlanung /> },
    { key: "kunden", label: "Kunden", render: () => <Sub gruppe="kunden" subs={kundenSubs} /> },
    { key: "team", label: "Team", count: z.urlaub, render: () => <CRMVerfuegbarkeiten /> },
    { key: "meldungen", label: "Meldungen & Aufgaben", kurz: "Meldungen", count: z.klaerung, render: () => <Sub gruppe="meldungen" subs={meldungSubs} /> },
    { key: "werbung", label: "Werbung", render: () => <CRMWerbung /> },
  ];
  return <><AltTabWeiterleitung /><BereichSeite titel="Alltagsbegleitung" untertitel="Kunden, Einsatzteam, Tourenoptimierung, Meldungen & Aufgaben und Werbung" icon={HeartHandshake} tabs={tabs} /></>;
}

const ALT_TAB = { aufgaben: ["meldungen", "aufgaben"], ausfaelle: ["meldungen", "ausfaelle"], kundenkontakte: ["kunden", "kontakte"], anfragen: ["kunden", "anfragen"] };

function AltTabWeiterleitung() {
  const [params, setParams] = useSearchParams();
  const alt = ALT_TAB[params.get("tab")];
  useEffect(() => { if (alt) { const p = new URLSearchParams(params); p.set("tab", alt[0]); p.set("sub", alt[1]); setParams(p, { replace: true }); } }, [alt]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function SubTabs({ gruppe, subs }) {
  const [params, setParams] = useSearchParams();
  const aktiv = subs.find(([k]) => k === params.get("sub"))?.[0] || subs[0][0];
  const setSub = (k) => { const p = new URLSearchParams(params); p.set("sub", k); setParams(p, { replace: true }); };
  const render = subs.find(([k]) => k === aktiv)[2];
  return (
    <div data-testid={`subtabs-${gruppe}`}>
      {subs.length > 1 && <div className="flex gap-1 mb-3 overflow-x-auto [scrollbar-width:none]" role="tablist">{subs.map(([k, l]) => <button key={k} role="tab" aria-selected={aktiv === k} onClick={() => setSub(k)} data-testid={`subtab-${k}`} className={`h-9 px-3 rounded-lg text-sm font-semibold whitespace-nowrap ${aktiv === k ? "bg-cyan-50 text-cyan-800 border border-cyan-200" : "text-slate-600 hover:bg-slate-100"}`}>{l}</button>)}</div>}
      {render()}
    </div>
  );
}
